import React, { useState, useEffect } from "react";
import authCss from "./ConversionAuth.module.css";
import MenuBar from "../UI/Menu/Menu";
import { Input } from "../UI/Input/Input";
import { ButtonSubmitBlack } from "../UI/Buttons/Buttons";
import { Send, School, Speed, AutoGraph, Stars } from '@mui/icons-material';
import { Grid } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ThreeCircles } from 'react-loader-spinner';
import PasswordChecklist from "react-multiple-password-validator";
import { useDispatch } from "react-redux";
import { setEmail, setFetching } from "../../redux/states";
import { fetchIp } from "../../utils/client-functions";
import { useErrorSetter } from '../../hooks/useUiMessages';
import { useTestimonials } from "../../hooks/useTestimonials";
import { reviewDetails } from '../../utils/reviews';

import SHA256 from 'crypto-js/sha256';
import CryptoJS from 'crypto-js';
import { init, track } from 'fbq';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
    all: { breakpoint: { max: 4000, min: 0 }, items: 1 }
};

const Register = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const screenWidth = window.innerWidth;
    
    const [user, setUser] = useState({
        firstName: '', lastName: '', email: '', password: '', confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [refParam, setRefParam] = useState("");
    const [pwdChecklist, showPwdChecklist] = useState(false);

    const isUserRegistered = localStorage?.getItem('isRegUse6aghajghdjfja');
    const isEmailRegistered = localStorage.getItem('isRegEm6aghajghdjfja');

    const errorSetter = useErrorSetter();
    const testimonialsData = useTestimonials();
    const displayReviews = (testimonialsData && testimonialsData.length > 0) ? testimonialsData : reviewDetails;

    useEffect(() => {
        const isAuth = localStorage?.getItem('token');
        const prevPath = sessionStorage?.getItem("prevPath");
        if (isAuth) {
            navigate(prevPath || '/');
        }
    }, [navigate]);

    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search);
            const ref = params.get('ref');
            if (ref) setRefParam(ref);
        } catch (_) {}
    }, []);

    const checkPassword = (password) => {
        const specialChars = /[!#$%&'()*+,-./:;<=>?@[\]^_{|}~]/;
        const numbers = /[0-9]/;
        return password.length >= 8 && specialChars.test(password) && numbers.test(password);
    };

    async function sendToFacebookConversionAPI(data) {
        try {
            await fetch('https://graph.facebook.com/v20.0/1133510054551065/events', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer EAAGOA8VGfuwBO5tWGc2njMdXV5CqSBsyFQCCwEdXcgdZB4ZAG6uZAldREnbZAROzBZCyZAVRkOxxWpKC83rVjDBL0TKq90mnc9pZAma45pFioO5h5INQr6FcE2qHWcF9Oqfwqd6LWE0WcYsFTaIzliSmWWMw9szljshEMom12ahJsB41SAZCOclWVI6aJiBtPJCv3QZDZD`
                },
                body: JSON.stringify({ "data": [data] })
            });
        } catch (error) {}
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if(!checkPassword(user.password)) {
            setLoading(false);
            return errorSetter("Password too weak");
        }

        if (isUserRegistered === 'true') {
            setLoading(false);
            errorSetter('You have already registered to Bubble Ai with another email: ' + isEmailRegistered + '. Avoid getting permanently banned.');
            return navigate("/popin");
        }

        if (user.password === user.confirmPassword){
            try {
                await axios.post('/auth/register', {
                    ...user, ref: refParam || undefined
                });

                const eventId = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
                const clientIp = await fetchIp();
                const fbData = {
                    "event_name": "CompleteRegistration",
                    "event_id": eventId,
                    "event_time": Math.floor(Date.now() / 1000),
                    "action_source": "website",
                    "event_source_url": window.location.href,
                    "user_data": {
                        "fn": [SHA256(user?.firstName).toString()],
                        "ln": [SHA256(user?.lastName).toString()],
                        "em": [SHA256(user.email).toString()],
                        "client_user_agent": navigator.userAgent,
                        "client_ip_address": clientIp
                    }
                };
                init('1133510054551065');
                track('CompleteRegistration', { eventID: eventId });
                await sendToFacebookConversionAPI(fbData);

                setLoading(false);
                dispatch(setEmail(user.email));
                navigate("/verify");

            } catch (error) {
                setLoading(false);
                errorSetter(error?.response?.data?.message || 'Registration failed');
            }
        } else {
            errorSetter('Passwords do not match');
            setLoading(false);
        }
    };

    const handleGoogleLogin = async (credentialResponse) => {
        if (isUserRegistered === 'true') {
            return errorSetter('You have already registered previously. Please Login.');
        }
        dispatch(setFetching(true));
        try {
            const token = credentialResponse.credential;
            if(token) {
                const decodedToken = jwtDecode(token);
                const response = await axios.post('/auth/google-register', {
                    email: decodedToken.email,
                    firstName: decodedToken.given_name,
                    lastName: decodedToken.family_name,
                    password: decodedToken.jti,
                    ref: refParam || undefined,
                });
                localStorage.setItem('token', response?.data?.user);
                navigate('/');
            } else {
                errorSetter('Process Failed');
            }
        } catch (error) {
            errorSetter('Bad Response');
        } finally {
            dispatch(setFetching(false));
        }
    };

    const handleInputChange = (prop) => (event) => setUser({ ...user, [prop]: event.target.value});

    return (
        <div>
            <MenuBar />
            <div className={authCss.authContainer}>
                
                <div className={authCss.blobBackground}>
                    <div className={authCss.blobAnimated} style={{ width: '400px', height: '400px', background: 'radial-gradient(circle, rgba(95,190,197,0.3) 0%, rgba(0,0,0,0) 70%)', borderRadius: '50%', top: '-10%', left: '-10%', position: 'absolute' }}></div>
                    <div className={authCss.blobAnimated} style={{ width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(23,60,80,0.4) 0%, rgba(0,0,0,0) 70%)', borderRadius: '50%', bottom: '-20%', right: '-10%', position: 'absolute' }}></div>
                </div>

                <div className={authCss.formContainer}>
                    <div className={authCss.splitLayout}>
                        <div className={authCss.leftPanel}>
                            <div style={{display: 'inline-block', background: 'rgba(95, 190, 197, 0.2)', padding: '5px 15px', borderRadius: '20px', marginBottom: '15px', fontWeight: 'bold', fontSize: '0.85rem', color: '#5fbec5', border: '1px solid #5fbec5'}}>
                                 GET STARTED FOR FREE
                            </div>
                            <h2 style={{fontSize: '2.5rem', marginBottom: '15px'}}>Supercharge Your Career</h2>
                            <p style={{fontSize: '1.05rem', lineHeight: '1.6', opacity: 0.9, marginBottom: '0'}}>
                                Join thousands utilizing Bubble Ai to automate applications, craft pro CVs, and crush their exams with AI simulators.
                            </p>
                            
                            <ul className={authCss.benefitList}>
                                <li><Speed /> <span>10x faster job applications</span></li>
                                <li><AutoGraph /> <span>ATS-beating resumes & covers</span></li>
                                <li><School /> <span>AI Exam Mock with 80%+ exam score guarantee</span></li>
                            </ul>

                            <div style={{marginTop: 'auto'}}>
                                <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                                    <div style={{display: 'flex'}}>
                                        {[1,2,3,4,5].map(i => <Stars key={i} style={{color: '#FFD700', fontSize: '1.2rem'}}/>)}
                                    </div>
                                    <span style={{marginLeft: '10px', fontSize: '0.9rem', opacity: 0.8}}>Loved by 10,000+ users</span>
                                </div>
                                <Carousel
                                    autoPlay={true}
                                    autoPlaySpeed={5000}
                                    infinite={true}
                                    arrows={false}
                                    responsive={responsive}
                                    containerClass="carousel-container"
                                    itemClass="carousel-item"
                                >
                                    {displayReviews?.slice(0, 3).map((detail, index) => (
                                        <div key={index} className={authCss.socialProof} style={{margin: 0}}>
                                            <p>"{detail?.comment || detail?.review || detail?.message}"</p>
                                            <span className={authCss.author}> {detail?.name}</span>
                                        </div>
                                    ))}
                                </Carousel>
                            </div>
                        </div>

                        <div className={authCss.rightPanel}>
                            <div className={authCss.formInner} style={{maxWidth: '450px'}}>
                                <h2>Create Account</h2>
                                <p className={authCss.subtitle}>Takes less than 30 seconds</p>

                                <form onSubmit={handleFormSubmit}>
                                    <div className={authCss.googleBtnWrapper}>
                                        <GoogleLogin
                                            onSuccess={handleGoogleLogin}
                                            onError={() => errorSetter('Login Failed')}
                                            auto_select={true}
                                            shape='pill'
                                            text="signup_with"
                                            width={screenWidth < 450 ? '300px' : '360px'}
                                        />
                                    </div>
                                    
                                    <div className={authCss.divider}>OR WITH EMAIL</div>

                                    <Grid container spacing={2} style={{marginBottom: '10px'}}>
                                        <Grid item xs={6}>
                                            <Input id="firstName" placeholder="First Name..." value={user.firstName} inputType="text" inputGridSm={12} onChange={handleInputChange('firstName')} /> 
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Input id="lastName" placeholder="Last Name..." value={user.lastName} inputType="text" inputGridSm={12} onChange={handleInputChange('lastName')} /> 
                                        </Grid>
                                    </Grid>

                                    <div className={authCss.inputGroup}>
                                        <Input id="email" placeholder="Email Address..." value={user.email} inputType="email" inputGridSm={12} onChange={handleInputChange('email')} /> 
                                    </div>
                                    <div className={authCss.inputGroup}>
                                        <Input id="password" placeholder="Password..." value={user.password} inputType="password" inputGridSm={12} onChange={handleInputChange('password')} onFocus={() => showPwdChecklist(true)} />
                                    </div>
                                    <div className={authCss.inputGroup}>
                                        <Input id="confirmPassword" placeholder="Confirm Password..." value={user.confirmPassword} inputType="password" inputGridSm={12} onChange={handleInputChange('confirmPassword')} onFocus={() => showPwdChecklist(true)} />
                                    </div>

                                    {pwdChecklist && (
                                        <div style={{color: '#0c1e28', background: 'rgba(0,0,0,0.03)', padding: '10px', borderRadius: '8px', marginBottom: '15px', fontSize: '0.75rem', textAlign: 'left'}}>
                                            <PasswordChecklist
                                                iconSize={12}
                                                rules={["minLength","specialChar","number","capital","match"]}
                                                minLength={8}
                                                value={user.password}
                                                valueAgain={user.confirmPassword}
                                                specialCharLength={1}
                                                numberLength={1}
                                                capitalLength={1}
                                                messages={{
                                                    minLength: "At least 8 characters",
                                                    specialChar: "One special character (!@#$)",
                                                    number: "One number",
                                                    capital: "One capital letter",
                                                    match: "Passwords match",
                                                }}
                                            />
                                        </div>
                                    )}

                                    <div className={authCss.forgotPasswordWrapper} style={{justifyContent: 'center', marginTop: '10px'}}>
                                        <span style={{fontSize: '0.9rem', color: '#666'}}>
                                            Already have an account? <span className={authCss.pwdRec} onClick={() => navigate("/popin")}>Sign In</span>
                                        </span>
                                    </div>

                                    <div className={authCss.submitBtnWrapper}>
                                        <ButtonSubmitBlack type="submit">
                                            {!loading ? <span>Join Free <Send style={{fontSize: '1.2rem', marginLeft: '5px', verticalAlign: 'middle'}}/></span> : 
                                            <ThreeCircles height="25" width="25" color="#FFFFFF" visible={true} />}
                                        </ButtonSubmitBlack>
                                    </div>

                                    <div className={authCss.agreement}>
                                        By registering, you agree to our <a href="/privacy" target="_blank" rel="noreferrer" style={{color: '#3E8F93', textDecoration: 'none'}}>Terms & Privacy Policy</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    )
}
export default Register;
